import { WorkspaceComment } from "@/models/workspace/WorkspaceComment";
import { FC } from "react";
import { standardHoverFocus, standardStyling } from "./utils/StandardStyles";
import useCommentsStore from "@/stores/comments.store";

interface ViewCommentsButtonProps {
  comment: WorkspaceComment;
}

const ViewCommentsButton: FC<ViewCommentsButtonProps> = ({ comment }) => {
  const { hoveredThread, setHoveredThread, toggleReplies, openReplies } =
    useCommentsStore();

  const calculateNumberOfReplies = (comment: WorkspaceComment) => {
    let totalReplies = 0;

    // Count direct replies
    const directReplies = comment.replies?.length || 0;
    totalReplies += directReplies;

    // Count nested replies recursively
    for (const reply of comment.replies || []) {
      if (reply.replies) {
        totalReplies += reply.replies.length;
        // Count any deeper nested replies
        for (const nestedReply of reply.replies) {
          totalReplies += nestedReply.replies?.length || 0;
        }
      }
    }
    return totalReplies;
  };

  return (
    <div className="relative ml-4 mb-2">
      <div
        className={`${standardStyling} -left-0 top-1/2 w-[26px] h-[24px] transform -translate-x-[33px] -translate-y-[22px] ${
          hoveredThread === comment.id
            ? "border-primary"
            : "border-border"
        }`}
        onClick={(e) => {
          e.stopPropagation();
          toggleReplies(comment.id);
        }}
        onMouseEnter={() => setHoveredThread(comment.id)}
        onMouseLeave={() => setHoveredThread(null)}
      >
        <div
          className={standardHoverFocus}
          onClick={(e) => {
            e.stopPropagation();
            toggleReplies(comment.id);
          }}
        />
      </div>
      <button
        className="text-sm text-primary hover:text-primary/80"
        onClick={() => openReplies(comment.id)}
        onMouseEnter={() => setHoveredThread(comment.id)}
        onMouseLeave={() => setHoveredThread(null)}
      >
        {`Se ${
          calculateNumberOfReplies(comment) > 1
            ? `alle ${calculateNumberOfReplies(comment)} kommentarer`
            : "1 kommentar"
        }`}
      </button>
    </div>
  );
};

export default ViewCommentsButton;
